import * as scheduleSchemas from './schedule';

export const schema = { ...scheduleSchemas };
